export const LocalStorageKeys = Object.freeze({
  SIDEBAR_COLLAPSED: "sidebar-collapsed",
  SIDEBAR_OPEN_SECTIONS: "sidebar-open-sections",
  B2B_SIDEBAR_COLLAPSED: "b2b-sidebar-collapsed",
});
